export default __webpack_public_path__ + "static/media/travelbag.12fee4cc.png";